import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { safeHttpUrl } from '../safe-url';

/**
 * SIL-1830 - the one way to render a stored / API-supplied URL as a link.
 * http(s) renders `<a target="_blank" rel="noopener noreferrer">`; anything
 * else (javascript:, data:, vbscript:, relative, garbage) renders as plain
 * text, never as a link. `fallback` replaces the text when the URL is unsafe
 * (default: the children, else the raw value, so the analyst can still see
 * what is stored).
 */
export function SafeLink({
  href,
  children,
  fallback,
  ...rest
}: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'> & {
  href: string | null | undefined;
  children?: ReactNode;
  fallback?: ReactNode;
}) {
  const safe = safeHttpUrl(href);
  if (!safe) {
    return <span className={rest.className} title={rest.title}>{fallback ?? children ?? href ?? null}</span>;
  }
  return (
    <a {...rest} href={safe} target="_blank" rel="noopener noreferrer">
      {children ?? safe}
    </a>
  );
}
